import React from 'react'
import Box from '../components/Box'

export default function Section13() {
    return (
        <div className="section">
            <h2>Section XIII: Data</h2>
            <p>Tap the “Data” button from the main screen and select from the following options:</p>
            <Box sectionData={'start'} title={'Reports'} body={`Class Report Generator
Launches the report generator as described in Section XIII.
Student Report Generator
Launches the report generator as described in Section XIII.
Assignment Report Generator
Launches the report generator as described in Section XIII.
Open Existing Report:
Use this feature to open a document in a preview window. Documents can be previewed, printed, or
sent to an external editor from the preview window. All generated .csv and .pdf files are available for
viewing.`} />
            <Box title={'File Management'} body={`Save Database File 
            Save the database backup file (GradeBookPro.sqlite file) to any location accessible via the iOS Share 
            Sheet.  Popular destinations are iCloud Drive, Dropbox, Google Drive, Email, and Air Drop. 
            Open Database File 
            Open a database backup file (GradeBookPro.sqlite) from any location accessible via the iOS 
            document picker.  Dropbox, Box, iCloud Drive, Google Drive are all popular choices. Note that the 
            source app must be installed.  
            Email Database File: 
            This will email a copy of your GradeBook Pro database file (containing all data). Use this to create a 
            backup copy of your database or if requested for support. 
            Clean Documents Directory: 
            Tap to delete all .pdf, .csv, .gbr, and .gbs files located in the /Documents directory. `} />

            <Box title={'Dropbox'} body={`Link / Unlink:
The title of this button reflects whether or not you are currently linked to your Dropbox account. If the
button title is “Unlink” the session is valid and file uploads are active. If the button title is “Link” you
must first click the button and proceed through the login sequence before files can be uploaded.
Database Backup:
Saves all data and uploads the database file to the linked Dropbox account. A unique folder is created
based on the current date.
!
25
Restore Database:
Important Note: This feature will replace the database file on your device. If you have entered data
since the backup file being restores it will be lost.
This feature retrieves a list of all directories in the Dropbox /GradeBook Pro/Backup directory. Select
the directory that contains the backup file to be restored. If there is a backup file in the selected
directory it will be downloaded and will replace the current database file.
Download Roster Import Files
If there are .csv or .gbr files in the Dropbox /GradeBook Pro/Import/Rosters directory they will be
retrieved and placed in the iOS Device /Documents directory. Retrieved files can be selected in the
“Import” function for a class roster.
Download Score Import Files
If there are .gbs files in the Dropbox /GradeBook Pro/Import/Scores directory they will be retrieved
and placed in the iOS Device /Documents directory. Retrieved files can be selected in the “Import”
function for an assignment grade entry.`} />

            <Box sectionData={'end'} title={'Security'} body={`Passcode Manager: 
            Enable, disable, or change the app launch passcode.   Note that the passcode is intended to prevent 
            unauthorized launching of the app, it does not encrypt or password protect the database or any report 
            files.`} />
        </div>
    )
}
